export default __webpack_public_path__ + "static/media/cer9.0aa710e6.png";